<template>
  <el-select
    v-bind="$attrs"
    v-model="selectedValue"
    filterable
    clearable
    :placeholder="placeholder"
    v-on="$listeners"
  >
    <el-option
      v-for="item in options"
      :key="item.flightPlanId"
      :label="item.flightPlanTime"
      :value="item.flightPlanTime"
      :disabled="item.disabled"
    />
    <template #[slotName] v-for="(slot, slotName) in $slots">
      <slot :name="slotName"></slot>
    </template>
  </el-select>
</template>

<script>
  import { getFlightTime, getFlightTime2 } from '@/api/intercityorder'
  export default {
    name: 'YdLineTimeSelect',
    props: {
      value: {
        type: [String, Number, Array],
        required: true
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      lineId: {
        type: [Number, Array],
        required: true
      }
    },
    data() {
      return {
        options: []
      }
    },
    computed: {
      selectedValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        }
      }
    },
    watch: {
      lineId: {
        handler(nVal) {
          if (nVal) {
            this.getList(nVal)
          }
        },
        immediate: true
      }
    },
    methods: {
      async getList(lineId) {
        // 兼容线路多选情况 lineId类型为object为多选  用getFlightTime2获取班次时间
        const getTime = typeof lineId === 'object' ? getFlightTime2 : getFlightTime
        const { code, data } = await getTime(lineId)
        if (code !== 0) {
          return
        }
        this.options = data && data.flightPlanVOList ? data.flightPlanVOList : []
      }
    }
  }
</script>

<style lang="scss" scoped></style>
